import { Component, ToCanvas } from 'shimmer'

import { VideoTexture, CanvasTexture } from 'three'
import { emitter } from '@/utils/emitter'

export class Screen extends Component {
  constructor (url, object) {
    super()

    this.createScreen = this.createScreen.bind(this)

    this.url = url
    this.object = object
    // should trhow this away with new model
    this.add(this.object)

    // this.promise = this.createPlayer()
    // this.promise.then(this.createScreen)
    this.createScreen()
    // this.addDebug()

    emitter.once('clicked', () => {
      this.toCanvas.start()
    })
  }

  createPlayer () {
    this.video = document.createElement('video')
    this.video.crossOrigin = 'anonymous'
    this.video.autoplay = true
    this.video.src = this.url
    this.video.muted = true
    this.video.load()

    return new Promise((resolve, reject) => {
      this.video.addEventListener('loadedmetadata', event => {
        resolve()
      })
    })
  }

  addDebug() {
    this.toCanvas.canvas.style.position = 'absolute'
    this.toCanvas.canvas.style.top = 0
    this.toCanvas.canvas.style.left = 0
    this.toCanvas.canvas.style.width = '100px'

    document.body.appendChild(this.toCanvas.canvas)
  }

  // createScreen () {
  //   this.texture = new VideoTexture(this.video)
  //   this.texture.wrapS = ClampToEdgeWrapping
  //   this.texture.wrapT = RepeatWrapping
  //   this.texture.needsUpdate = true
  //   this.object.material.map = this.texture
  //   this.object.material.needsUpdate = true
  // }

  onUpdate () {
    if (this.texture) {
      this.texture.needsUpdate = true
    }
  }

  createScreen () {
    this.toCanvas = new ToCanvas({video: this.url, width: 1024, height: 512, muted: true})
    this.toCanvas.promise.then(() => {
      this.texture = new CanvasTexture(this.toCanvas.canvas)
      this.object.material.map = this.texture
      this.object.material.needsUpdate = true
    })
  }
}